const doc = [({"en":({"js":({"admin":({"highscores":({"organizations":({"search_for_an_organisation_to_add_it":"Search for an organization to add it"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;